import { render, staticRenderFns } from "./TqChart.vue?vue&type=template&id=bd6721fa&scoped=true&"
import script from "./TqChart.vue?vue&type=script&lang=js&"
export * from "./TqChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6721fa",
  null
  
)

export default component.exports